/** Times the way people say them: "just now", "12 minutes ago", "yesterday at 9:41 pm", "21 Oct". */

const clock = (d: Date) => d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }).toLowerCase();

export function ago(ms: number, now = Date.now()): string {
  const s = Math.max(0, (now - ms) / 1000);
  if (s < 45) return 'just now';
  if (s < 90) return 'a minute ago';
  if (s < 3600) return `${Math.round(s / 60)} minutes ago`;
  const d = new Date(ms);
  const today = new Date(now);
  const sameDay = d.toDateString() === today.toDateString();
  if (sameDay) return s < 5400 ? 'an hour ago' : s < 6 * 3600 ? `${Math.round(s / 3600)} hours ago` : `today at ${clock(d)}`;
  const yesterday = new Date(now - 86_400_000);
  if (d.toDateString() === yesterday.toDateString()) return `yesterday at ${clock(d)}`;
  return d.toLocaleDateString([], { day: 'numeric', month: 'short', year: d.getFullYear() === today.getFullYear() ? undefined : 'numeric' });
}

/** An event's dates: "20 Nov 2026", "20–22 Nov 2026", "30 Nov – 2 Dec 2026". */
export function days(startsOn: string | null, endsOn: string | null): string {
  if (!startsOn) return '';
  const day = (s: string) => {
    const [y, m, d] = s.split('-').map(Number) as [number, number, number];
    return new Date(y, m - 1, d);
  };
  const a = day(startsOn);
  const fmt = (d: Date, o: Intl.DateTimeFormatOptions) => d.toLocaleDateString('en-GB', o);
  if (!endsOn || endsOn === startsOn) return fmt(a, { day: 'numeric', month: 'short', year: 'numeric' });
  const b = day(endsOn);
  if (a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth()) return `${a.getDate()}–${fmt(b, { day: 'numeric', month: 'short', year: 'numeric' })}`;
  if (a.getFullYear() === b.getFullYear()) return `${fmt(a, { day: 'numeric', month: 'short' })} – ${fmt(b, { day: 'numeric', month: 'short', year: 'numeric' })}`;
  return `${fmt(a, { day: 'numeric', month: 'short', year: 'numeric' })} – ${fmt(b, { day: 'numeric', month: 'short', year: 'numeric' })}`;
}
